import { render, staticRenderFns } from "./xindianStation.vue?vue&type=template&id=5ea2156e&scoped=true&"
import script from "./xindianStation.vue?vue&type=script&lang=js&"
export * from "./xindianStation.vue?vue&type=script&lang=js&"
import style0 from "./xindianStation.vue?vue&type=style&index=0&id=5ea2156e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea2156e",
  null
  
)

export default component.exports